// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_CreditPurchaseSyncResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * AiCredits_CreditPurchaseSyncResponse — result of
 * POST /ai/credits/admin/sync/{franquia_id} (fase 1b of the platform-revenue
 * refactor, docs/platform-revenue-refactor-plan.md).
 *
 * The credits lane's OWN reconciliation door — scoped to a FRANCHISE, never
 * to a subscription. Delegates entirely to SubscriptionReconciliationService::
 * reconcileCreditPurchasesForFranchise(): every PENDING ai_credit_purchases
 * row for this franchise is read, its provider resolved from the
 * platform-revenue ledger (never from any subscription, which may live on an
 * entirely different gateway), and pulled from the provider it actually
 * lives on.
 *
 * Reuses Subscriptions_SubscriptionSyncRow — the per-remote-charge outcome
 * shape (charge_id, remote_status, action, detail, lane) is identical to the
 * subscription-cycle sweep's own row; `lane` (always 'credit_purchase' here)
 * is what tells the two sweeps' rows apart if a caller ever merges them for
 * display.
 */
import type { Subscriptions_SubscriptionSyncRow } from './Subscriptions_SubscriptionSyncRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_CreditPurchaseSyncResponseDados {
franquia_id: number
rows: Subscriptions_SubscriptionSyncRow[]
}

export type AiCredits_CreditPurchaseSyncResponse = ApiResponse<AiCredits_CreditPurchaseSyncResponseDados>;

registerResponseContract('AiCredits_CreditPurchaseSyncResponse', {
  franquia_id: { type: 'number',  required: true },
  rows: {
    type: 'array',
    required: true,
    items: {
      charge_id:     { type: 'string',  required: false },
      remote_status: { type: 'string',  required: false },
      action:        { type: 'string',  required: false },
      detail:        { type: 'string',  required: false },
      lane:          { type: 'string',  required: false },
    },
  },
})
